import { formatTemperature } from '../../util/temperature';
import { useTemperatureUnit } from '../../util/useTemperatureUnit';

function StatusBar({ value, type, isNegative }) {
  const temperatureUnit = useTemperatureUnit();
  const config = {
    status: {
      barColor:
        value <= 25 ? "bg-success text-black" :
        value <= 74 ? "bg-warning text-black" :
        "bg-danger",
      width: value,
      min: 0,
      max: 100,
      unit: "%",
    },
    portfolioPercent: {
      barColor:
        value > 90 ? "bg-success text-black" :
        value >= 20 ? "bg-warning text-black" :
        "bg-danger text-black",
      width: value,
      min: 0,
      max: 100,
      unit: "%",
    },
    capacity: {
      barColor:
        value > 35 ? "bg-success text-black" :
        value >= 25 ? "bg-warning text-black" :
        "bg-danger text-black",
      width: value,
      min: 0,
      max: 100,
      unit: "%",
    },
    soc: {
      barColor:
        value > 90 ? "bg-success text-black" :
        value >= 20 ? "bg-warning text-black" :
        "bg-danger text-red",
      width: value,
      min: 0,
      max: 100,
      unit: "%",
    },
    performance: {
      barColor:
        value > 90 ? "bg-success text-black" :
        value >= 20 ? "bg-warning text-black" :
        "bg-danger text-black",
      width: value,
      min: 0,
      max: 100,
      unit: "%",
    },
    angle: {
      barColor:
        value < -10 ? "bg-danger text-white" :
        value < -4 ? "bg-warning text-black" :
        value < 0 ? "bg-success text-black" :
        value <= 4 ? "bg-success text-black" :
        value <= 10 ? "bg-warning text-black" :
        "bg-danger text-white",
      width: (Math.abs(value) / 20) * 100,
      min: -20,
      max: 20,
      unit: "°",
    },
    availability: {
      barColor:
        value <= 25 ? "bg-danger text-black" :
        value <= 74 ? "bg-warning text-black" :
        "bg-success",
      width: value,
      min: 0,
      max: 100,
      unit: "%",
    },
    thermometer: {
      barColor:
        value <= 60 ? "bg-info text-black" :
        value <= 75 ? "bg-success text-white" :
        value <= 90 ? "bg-warning text-black" :
        "bg-danger",
      width: (value / 120) * 100,
      min: -120,
      max: 120,
      unit: "°F",
    },
  };

  const selected = config[type];
  const barColor = selected.barColor;
  const width = selected.width;
  const min = selected.min;
  const max = selected.max;
  const unit = type === 'thermometer'
    ? ''
    : selected.unit;
  const label = type === 'thermometer'
    ? formatTemperature(value, temperatureUnit)
    : `${value}${unit}`;
  const alignment = isNegative ? "justify-content-end" : "justify-content-start";

  return (
    <div className={`progress ${alignment}`} role="progressbar" aria-label="Generation" aria-valuenow={value} aria-valuemin={min} aria-valuemax={max}>
      <div className={`progress-bar progress-bar-striped progress-bar-animated ${barColor}`} style={{ width: `${width}%` }}><span>{label}</span></div>
    </div>
  );
}

export default StatusBar;
